import type { Dictionary } from '@noths/polaris-dev-ts-recipes';

type RemappedType<Type extends Dictionary, TPrefix extends string> = {
  [Key in keyof Type as `${TPrefix}${string & Key}`]: Type[Key];
};

export const cloneObjectWithPrefixedProperties = <
  Type extends Dictionary,
  TPrefix extends string,
  TRemappedType = RemappedType<Type, TPrefix>,
>(
  object: Type | undefined,
  prefix: TPrefix,
) => {
  if (!object) {
    return {};
  }

  return Object.entries(object).reduce<TRemappedType>((newObj, [key, value]) => {
    newObj[`${prefix}${key}` as keyof TRemappedType] = value as TRemappedType[keyof TRemappedType];

    return newObj;
  }, {} as TRemappedType);
};

export interface ObjectPropertyNameMatcher {
  newName: string;
  oldNameMatcher: RegExp;
}

export const cloneObjectWithCollapsingProperties = (
  obj: Record<string, string>,
  matchers: ObjectPropertyNameMatcher[],
): Record<string, string> => {
  const newObj = {};

  Object.entries(obj).forEach(([propertyName, propertyValue]) => {
    const match = matchers.find(({ oldNameMatcher }) => {
      return oldNameMatcher.test(propertyName);
    });
    const name = match ? match.newName : propertyName;

    newObj[name] = propertyValue;
  });

  return newObj;
};
